import React, { useCallback, useEffect, useRef, useState } from "react";
import { Field, change, formValueSelector } from "redux-form";
import { useDispatch, useSelector } from "react-redux";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { ContentState, EditorState, convertToRaw } from "draft-js";

import emailEditor from "../../../../../../../../common/EmailEditor";
import styles from "../../../../../../JobStyle.module.css";

const FORM_NAME = "JobSwmsV3EmergencyProceduresContainerForm";
const selector = formValueSelector(FORM_NAME);

export default function JobSwmsV3EmergencyProcedureRichTextSection({
  procedure,
  procedureIndex,
  sectionKey,
  label,
  loading
}) {
  const dispatch = useDispatch();
  const sectionData = procedure
    && procedure.sections
    && procedure.sections[sectionKey]
    && procedure.sections[sectionKey].data
    ? procedure.sections[sectionKey].data
    : {};
  const formHtml = useSelector((state) => selector(
    state,
    `procedures[${procedureIndex}].sections.${sectionKey}.data.content.html`
  ));
  const formToggle = useSelector((state) => selector(
    state,
    `procedures[${procedureIndex}].sections.${sectionKey}.data.toggle`
  ));
  const contentHtml = formHtml !== undefined
    ? formHtml
    : (sectionData.content && sectionData.content.html ? sectionData.content.html : "");
  const isIncluded = Number(
    formToggle === undefined ? sectionData.toggle : formToggle
  ) !== 0;
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const lastHtmlRef = useRef("");

  const getEditorStateFromHtml = useCallback((html = "") => {
    const blocksFromHtml = htmlToDraft(html);
    if (blocksFromHtml && blocksFromHtml.contentBlocks) {
      return EditorState.createWithContent(
        ContentState.createFromBlockArray(blocksFromHtml.contentBlocks)
      );
    }
    return EditorState.createEmpty();
  }, []);

  useEffect(() => {
    if (contentHtml !== lastHtmlRef.current) {
      lastHtmlRef.current = contentHtml;
      setEditorState(getEditorStateFromHtml(contentHtml));
    }
  }, [contentHtml, getEditorStateFromHtml]);

  const onEditorStateChange = (nextState) => {
    setEditorState(nextState);
    const html = draftToHtml(convertToRaw(nextState.getCurrentContent()));
    lastHtmlRef.current = html;
    dispatch(change(
      FORM_NAME,
      `procedures[${procedureIndex}].sections.${sectionKey}.data.content.html`,
      html
    ));
  };

  return (
    <div className="container-fluid pb-2">
      <div className="row pt-2">
        <div className="col-12">
          <div className={styles.Label}>{label}</div>
          <div className="swmsv2-custom-draft-editor">
            <Field
              name={`procedures[${procedureIndex}].sections.${sectionKey}.data.content.html`}
              component={emailEditor}
              editorState={editorState}
              onEditorStateChange={onEditorStateChange}
              disabled={loading || !isIncluded}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
